export default __webpack_public_path__ + "assets/images/7ff35836057766af00caa312421581df.svg";